import React from "react";

export const FormLabel = ({ children, ...props }) => {
  return (
    <label className="control-label" {...props}>
      {children}
    </label>
  );
};
